import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const headers = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// 📄 Obtener firmas del documento
export const getExpenseSignatures = (documentId) =>
  axios
    .get(`${API_URL}/api/expenses/${documentId}/signatures`, {
      headers: headers(),
    })
    .then((res) => res.data);

// ✍️ Firmar como empleado
export const signExpenseAsEmployee = (documentId) =>
  axios.post(
    `${API_URL}/api/expense-documents/${documentId}/sign/employee`,
    {},
    { headers: headers() }
  );

// ✍️ Firmar como manager
export const signExpenseAsManager = (documentId) =>
  axios.post(
    `${API_URL}/api/expense-documents/${documentId}/sign/manager`,
    {},
    { headers: headers() }
  );
